class linkage {
  state = {
    clienti: '',
    cognome: 'noval',
  };

  setValue = (clienti) => {
    this.state.clienti = clienti;

    console.log('param : ', this.state.clienti);
  };
  getValue = () => {
    console.log('return param : ', this.state);
    return this.state;
  };
}

export default new linkage();
